import styled, { css } from 'styled-components';
import { LinkProps } from '.';

export const LinkEstilizado = styled.span<LinkProps>`
  ${({ theme, $size, $weight, $color, $highContrast }) => {
    return css`
      font-size: ${theme.typography.font.size[$size]}px;
      font-family: var(--font-${theme.typography.font.family.text});
      font-weight: ${theme.typography.font.weight[$weight]};
      line-height: ${theme.typography.font.line_height[$size]}px;
      color: ${theme.colors[$color][$highContrast ? $color : `${$color}_alpha`][
        $highContrast ? '12' : '11'
      ]};
    `;
  }}

  text-decoration: ${({ $underline }) => ($underline ? 'underline' : 'none')};
`;
